import React, { memo, useCallback, useState } from 'react'
import { Button, Skeleton, Space, Tag } from 'antd'
import dayjs from 'dayjs'
import { CarOutlined } from '@ant-design/icons'
import { TimeLineContentHeaderWrapper, TimeLineContentWrapper } from '../../../styles/styles'
import { ActivityCall } from '../../../types/types'
import TimelineItemHeader from '../activity-timeline-item-header/activity-timeline-item-header'
import { TimelineItemProps } from '../activity-timeline-Item'
import { getCall } from '../../../api/getCall'

type ActivityTimelineCallType = Omit<TimelineItemProps, 'data'>

interface ActivityTimelineCallProps extends ActivityTimelineCallType {
  className?: string
  data?: ActivityCall
}

function callTimeFormat(endTime, startTime) {
  if (endTime && startTime) return dayjs(startTime * 1000).to(endTime * 1000, true)
  return 'пропущен'
}

const ActivityTimelineCall: React.FC<ActivityTimelineCallProps> = memo(
  (props: ActivityTimelineCallProps) => {
    const { date, data } = props
    const [isLoading, setIsLoading] = useState(false)
    const [calls, setCalls] = useState<string[]>([])

    const handleLoadCall = useCallback(() => {
      const id = data?.id
      if (!id) return
      setIsLoading(true)
      getCall(id)
        .then(response => {
          if (response && response?.length) {
            setCalls(response as string[])
          }
        })
        .finally(() => setIsLoading(false))
    }, [data])

    const isShowButton = !isLoading && !Boolean(calls.length) && Boolean(data?.records?.length)

    return (
      <TimeLineContentWrapper>
        <TimeLineContentHeaderWrapper>
          <TimelineItemHeader date={date} title={'Звонок'} />
          {data?.organization_type === 'delivery' && (
            <Tag icon={<CarOutlined />} color="green" style={{ marginRight: 0 }}>
              Доставка
            </Tag>
          )}
        </TimeLineContentHeaderWrapper>
        <Space>
          <span>Статус:</span>
          <span style={{ color: '#a8adb4' }}>{data?.status}</span>
        </Space>
        <Space>
          <span>Время разговора:</span>
          <span style={{ color: '#a8adb4' }}>
            {`${callTimeFormat(data?.finish, data?.answer)}`}
          </span>
        </Space>

        {isShowButton && (
          <Button type="default" onClick={handleLoadCall}>
            Загрузить звонок
          </Button>
        )}
        {!isLoading ? (
          Boolean(calls.length) && (
            <div>
              <div>Запись разговора:</div>
              <br />
              {calls.map((call, index) => (
                <audio
                  key={index}
                  controls
                  style={{ width: '100%', height: '30px' }}
                  preload="metadata"
                >
                  <source src={call} type="audio/mpeg"></source>
                </audio>
              ))}
            </div>
          )
        ) : (
          <Skeleton active />
        )}
      </TimeLineContentWrapper>
    )
  },
)

ActivityTimelineCall.displayName = 'ActivityTimelineCall'
export default ActivityTimelineCall
